<template>
  <div>
    <b-form @submit.prevent>
      <b-row>

        <b-col cols="12">
          <b-form-group
            label="Book Key"
            label-for="vi-id"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-id"
                v-model="book.id"
                placeholder="Book Id"
                disabled="disabled"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Title"
            label-for="vi-title"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-title"
                v-model="book.title"
                placeholder="Book Title"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
              label="Section ID"
              label-for="vi-section"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-input
                  id="vi-title"
                  v-model="book.section_id"
                  placeholder="Section ID"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
              label="Volume"
              label-for="vi-volume"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-input
                  id="vi-title"
                  v-model="book.volume"
                  placeholder="Volume"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Author"
            label-for="vi-author"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-author"
                v-model="book.author"
                placeholder="Book Author"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Path"
            label-for="vi-path"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="LinkIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-path"
                v-model="book.path"
                placeholder="Book path"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Icon"
            label-for="vi-path"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="LinkIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-icon"
                v-model="book.icon"
                placeholder="Book icon"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <img :src="book.icon" style="margin-bottom: 10px"/>
        </b-col>

        <b-col cols="12">
          <b-form-group
              label="Date Uploaded"
              label-for="vi-uploaded"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UploadIcon" />
              </b-input-group-prepend>
              <b-form-input
                  id="vi-title"
                  v-model="book.dateUploaded"
                  placeholder="Date Uploaded"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <div style="padding-bottom: 10px">
            <span style="font-weight: bold;padding-bottom: 10px">Created At: {{ formatDate(book.created) }}</span>,  Last update: {{ formatDate(book.updated) }}
          </div>
        </b-col>
        <!-- reset and submit -->
        <div class="demo-inline-spacing">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="saveBook"
          >
            Save
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="danger"
            class="mr-1"
            @click="askDelete"
          >
            Delete
          </b-button>
        </div>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BInputGroup, BInputGroupPrepend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      book: {},
    }
  },
  mounted() {
    const url = `${this.$readerURL}/admin/cpbooks/${this.$route.params.book}`
    this.loader('block')
    firebase.auth().currentUser.getIdToken(false).then(idToken => {
      axios.get(url,
        {
          headers: {
            Authorization: idToken,
          },
        }).then(response => {
        this.book = response.data
        this.loader('none')
        return response
      }).catch(error => {
        this.loader('none')
        this.$bvModal
          .msgBoxOk(`Book not found: ${error}`, {
            title: 'Info',
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Close',
            hideHeaderClose: false,
            centered: true,
          })
          .then(value => {
            this.$router.push('/books')
            return value
          })
      })
    })
  },
  methods: {
    askDelete() {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this book.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.deleteBook()
          }
        })
    },
    deleteBook() {
      this.loader('block')
      const url = `${this.$readerURL}/admin/cpbooks/${this.$route.params.book}`
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.delete(url,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          this.$router.push('/cpbooks/')
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    saveBook() {
      const url = `${this.$readerURL}/admin/cpbooks/${this.$route.params.book}`
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, this.book,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
  },
}
</script>
